import { __rest, __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import Triangle from '../../../../icons/Triangle.esm.js';
import omit from 'lodash/omit';
import styles from './NavigationElement.module.esm.js';

var NavigationElement = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, label = _a.fields.label, dataCy = _a.dataCy, props = __rest(_a, ["classes", "fields", "dataCy"]);
    if (!label)
        return null;
    var p = omit(props, 'rootElementProps', 'BaseComponent', 'originalFields');
    return (React.createElement("span", __assign({ className: classNames(styles.root, classes.root), "data-cy": dataCy }, p, { "data-testid": "navigation-el" }),
        React.createElement("span", null, label),
        React.createElement(Triangle, { title: "Go to ".concat(label, " page") })));
};
/* eslint-enable jsx-a11y/no-noninteractive-tabindex */

export { NavigationElement as default };
//# sourceMappingURL=NavigationElement.esm.js.map
